module.exports = __webpack_public_path__ + "static/img/logos.cecdcf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos.jpg
// module id = hnye
// module chunks = 1